// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

:host .hero--inner {
  min-height: 200px;
  position: relative;
  padding-right: 0;
}

:host .hero--inner .hero__image,
:host .hero--inner > img {
  position: absolute;
  z-index: 1;
  right: 84px;
  top: 50%;
  width: 494px;
  height: 100%;
  max-width: none;
  object-fit: cover;
  object-position: right top;
  pointer-events: none;
}

:host .cta .secondary-button,
:host .cta .secondary-button:hover,
:host .cta .secondary-button:focus-visible {
  text-decoration: none; 
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/app/LSR/participant/lsr_cro/lsr_cro.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;;;EAGE,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[":host {\r\n  display: block;\r\n}\r\n\r\n:host .hero--inner {\r\n  min-height: 200px;\r\n  position: relative;\r\n  padding-right: 0;\r\n}\r\n\r\n:host .hero--inner .hero__image,\r\n:host .hero--inner > img {\r\n  position: absolute;\r\n  z-index: 1;\r\n  right: 84px;\r\n  top: 50%;\r\n  width: 494px;\r\n  height: 100%;\r\n  max-width: none;\r\n  object-fit: cover;\r\n  object-position: right top;\r\n  pointer-events: none;\r\n}\r\n\r\n:host .cta .secondary-button,\r\n:host .cta .secondary-button:hover,\r\n:host .cta .secondary-button:focus-visible {\r\n  text-decoration: none; \r\n  font-size: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
